<template>
  <div
    v-if="currentError"
    class="ValidationError"
  >
    {{ $t(currentError) }}
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },

    errors: {
      type: Array,
      default: undefined,
    },
  },

  computed: {
    currentError() {
      if (!this.errors) return undefined;

      const currentError = this.errors.find(error => error.name === this.name);
      return currentError?.text;
    },
  },
};
</script>

<style lang="scss" scoped>
.ValidationError{
  font-size: $font-size-s;
  text-align: justify;
  padding: $spacing-xs;
  color: $color-error; //adjust-color($color-error, $lightness: 40%);
  background: transparent; //adjust-color($color-error, $alpha: -.3);
  animation: move .5s;
  position: relative;
  transition: all .5s ease;
  left: 0;
  opacity: 1;
  margin-top: $spacing-2xs;

  @keyframes move {
    0%{
      left: -$spacing-xl;
      opacity: 0;
    }
  }
}
</style>
